import React, { useState, ReactNode, createContext } from "react";
import { ISettingsContext, ISnack, ModalNotification, Service } from "Interfaces/SettingsContext";
import { useMediaQuery, useTheme } from "@mui/material";

export const SettingsContext = createContext<ISettingsContext | undefined>(undefined)

export const SettingsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const [service, setService] = useState<Service | null>(null)
    const [dialog, setDialog] = useState<ModalNotification>({
        open: false,
        message: "",
        title: ""
    })

    const [snackBar, setSnackBar] = useState<ISnack>({
        message: "",
        open: false,
        type: "success"
    })

    // Metodo para obtener las fechas en formato SQL
    const getDateFormat = (date: Date | any, format: 'sql' | 'normal'): string => {
        if (!(date instanceof Date)) date = new Date()
        let formattedDate = ''
        if (format === "sql") formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        else formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
        return formattedDate
    }

    return (
        <SettingsContext.Provider value={{
            service, setService,
            dialog, setDialog,
            snackBar, setSnackBar,
            getDateFormat,
            isMobile
        }}>
            {children}
        </SettingsContext.Provider>
    )
}